module.exports = __webpack_public_path__ + "img/any-num8.241d2a22.png";